import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const getUserProfileKitsOwned = async ({ uid }) => {
	try {
		const userProfileDocRef = firestore.collection('userProfiles').doc(uid)

		const kitsOwnedQuerySnap = await userProfileDocRef.collection('kitsOwned')
			.orderBy('createdTimestamp', 'desc')
			.get()

		const kitsOwned = kitsOwnedQuerySnap.docs.map(d => d.data())
		return kitsOwned
	} catch (error) {
		throw errorOfType(errorTypes.UNKNOWNERROR, uid, error)
	}
}

export default getUserProfileKitsOwned



// WEBPACK FOOTER //
// ./src/dataservices/getUserProfileKitsOwned.js